import styled from '@emotion/styled';

export const SimulationStepContent = styled.div``;

export const SimulationStepContainer = styled.div`
  margin-bottom: 32px;
`;
